export default {
  navBar:{
    proposal: '提案观测',
    language: 'Language',
    login: '登录',
    logout: '退出',
    SystemAdmin:'系统管理',
    UserCenter:'用户中心',
    userCenterinfo:'用户信息维护',
    applylist:'数据申请列表',
    authlist:'授权列表',
    downloadlist:'已下载列表',
    homepage:'主页',
    goback:'返回',
  },
  proposal:{
    obs_id:'观测号',
    schedule_id:'计划号',
    ptype:'提案类型',
    ptype_data:{
      C:'核心观测提案',
      T:'ToO观测提案',
      G:'客座观测提案',
      M:'临时观测提案',
    },
    obs_mode:'观测模式',
    obsmode_data:{
      P:'定点观测',
      S:'巡天观测',
      A:'小天区扫描',
    },
    target:'目标',
    ra:'Ra',
    dec:'Dec',
    offset:'偏轴标记',
    offset_c:'offset',
    tstart:'开始时间(TT)',
    tsop:'结束时间(TT)',
    start_utc:'开始时间(UTC)',
    stop_utc:'结束时间(UTC)',
    duration:'数据时长',
    status:'数据状态',
    status_data:{
      A:'已归档',
      P:'处理中',
      O:'已废弃',
      U:'不提供',
    },
    isopen:'公开',
    isopenstate:'公开状态:',
    isopen_data:{
      0:'未公开',
      1:'已公开',
    },
    operate:'操作',
    bulk_down:'批量下载',
    batch_application:'批量申请',
    apply:'申请',
    copy_downlink:'复制下载链接',
    get_wget:'获得wget命令',
    webdownload:'浏览器下载',
    bulkcopy_downlink:'批量复制下载链接',
    bulkget_wget:'批量获得wget命令',
    bulkwebdownload:'批量浏览器下载',
    download:'下载',
    UpPackage:'升级包',
    OwnerAuth:'Owner下载链接生成',
    full_name:'姓名',
    email:'电子邮箱',
    applycop:'机构',
    application_information:'申请信息',
    ok:'确定',
    cancel:'取消',
    id:'提案ID',
    pre_slew:'Pre-Slew',
    post_slew:'Post-Slew',
    data_mode:'数据模式',
    proposal:'提案号',
    observer:'提案人',
    speed:'扫描速度',
    interval:'扫描间隔',
    radius:'扫描半径',
    release_time:'发布时间',
    open_time:'公开日期',
    location: '坐标位置',
    owner:'权属',
    archive_time:'数据归档日期',
    l1_file_id:'1L文件ID',
    l15_file_id:'1.5L文件ID',
    l2_file_id:'2L文件ID',
    l1_file_v:'1L文件版本',
    l15_file_v:'1.5L文件版本',
    l2_file_v:'2L文件版本',
    create_time:'数据生成时间',
    create_by:'数据生成人',
    update_time:'数据更新时间',
    update_by:'数据更新人',
    condition: {
      target: '源名称',
      position: '坐标位置',
      radius: '搜索半径(°)',
      start_utc: '开始时间',
      stop_utc: '结束时间',
      isopen: '只显示公开数据',
      ptype: '提案类型',
      obs_mode:'观测模式',
      schedule_id: '计划ID',
      tstart: '开始时间（MET or MJD）',
      tstop: '结束时间（MET or MJD）',
      proposal: '提案号',
      isarchived: '只显示就绪的数据',
      all: '全部',
      download: '只显示可下载',
      appliable: '只显示可申请',
      more: '更多检索条件',
      search: '搜索',
      clear:'条件清除',
      less: '精简检索条件',
    },
    tip:{
      obs_id:'观测号',
      schedule_id:'观测计划任务号',
      tstart:'数据开始时间TT秒计数',
      tsop:'数据结束时间秒计数',
      duration:'数据时长',
      pre_slew:'观测前Slew时长',
      post_slew:'观测后Slew时长',
      target:'观测目标天体',
      obs_mode:'观测模式',
      data_mode:'数据模式',
      proposal:'提案号',
      ptype:'提案类型',
      status:'数据状态',
      speed:'扫描速度',
      Interval:'扫描间隔',
      radius:'扫描半径',
      offset:'Offset Flag',
      offset_c:'计算半径',
      isopen:'数据是否公开:1 公开  0 非公开',
      release_time:'数据发布时间',
      open_time:'数据公开时间',
    },
  },
  grb:{
    grb_id:'GRB_ID',
    trigger_time:'触发时间(MJD)',
    trigger_time_utc:'触发时间(UTC)',
    start_utc:'数据开始时间(UTC)',
    start_tt:'数据开始时间(TT)',
    duration:'观测时长',
    status:'数据状态',
    apply:'申请',
    relate_id:'Relate_ID',
    filesize:'文件大小',
    bulk_down:'批量下载',
    copy_downlink:'复制下载链接',
    get_wget:'获得wget命令',
    download:'下载',
    condition: {
      grb_id: 'GRB ID',
      obs_from: '数据开始时间',
      obs_to: '结束时间',
      search: '搜索',
    },
    tip:{
      grb_id:'暴发编号（HXMT）',
      start_utc:'数据开始时间(ISO 8601)',
      start_tt:'数据开始时间（HXMT-TT）',
      duration:'观测时长',
      status:'数据状态',
    },
  },
  sem:{
    date_utc:'观测日期(UTC)',
    date_mjd:'观测日期(mjd)',
    hxmt_day:'HXMT 观测天次',
    start_tt:'数据开始时间(TT)',
    stop_tt:'数据结束时间(TT)',
    duration:'观测时长',
    status:'数据状态',
    apply:'申请',
    bulk_down:'批量下载',
    copy_downlink:'复制下载链接',
    get_wget:'获得wget命令',
    download:'下载',
    condition: {
      obs_from: '开始时间',
      obs_to: '结束时间',
      search: '搜索',
    },
    tip:{
      date_utc:'数据开始时间(ISO 8601)',
      date_mjd:'数据开始时间(MJD)',
      duration:'观测时长',
      status:'数据状态',
    },
  },
  messinfo:{
    applying:'正在申请中，请等待邮箱回复',
    positioninput:'坐标位置ra、dec与搜索半径radius是一组输入条件，必须组合输入',
    rainput:'ra 为 [0,360) 的浮点数，或者为 hh mm ss 格式的字符串，hh范围 [0,24) 整数，mm范围[0,60) 整数，ss范围[0,60)浮点数，请检查输入！',
    decinput:'des 为 [-90,90]的浮点数，或者为 dd ff mm 格式的字符串，dd范围 [-90,90] 整数，ff范围[0,60) 整数，mm范围[0,60)浮点数，请检查输入！',
    radiusinput: 'radius为大于0的浮点数，请检查输入！',
  },
  noLoginApplyDialog: {
    id:'数据ID',
    ogs_id:'数据ID',//三个不同表的相应数据主键obs_id,grb_id,sem_id
    remark:'数据用途',
    application_information: '游客数据申请',
    name: '姓名',
    applyemail: '电子邮箱',
    applycop: '机构',
    cancel: '取消',
    ok: '确定',
    level:'数据级别',
    messinfo:{
      select_datalevel:'请选择数据级别!',
      lack_information:'请填写所有的申请信息(姓名,用途,邮箱,机构)!',
      mailbox_detection:'邮箱格式不正确!',

    },
    
  },
  LoginApplyDialog: {
    application_information: '用户申请信息',
    appbulk_information: '批量申请信息',
    name: '姓名',
    useremail: '邮箱',
    applycop: '机构',
    cancel: '取消',
    ok:'确定',
    id:'提案ID',
    obs_id:'观测号',
    proposal:'提案号',
    remark:'数据用途',
    userposition:'职务',
    userposition_tip:'请选择职位',
    tutorinfo:'导师信息',
    tutorname:'导师姓名',
    tutoremail:'导师邮箱',
    tutoropion:'导师意见',
    partnersinfo:'合作人信息',
    partnersname:'合作人姓名',
    partnersemail:'合作人邮箱',
    partnersopion:'合作人意见',
    includeproposal:{
      one:'申请此观测数据',
      two:'申请该提案的所有数据',
      three:'申请提案下相同目标天体数据',
    },
    required:' * 必填项', 
    messinfo:{
      useremailbox_detection:'用户邮箱格式不正确，请联系注册系统管理员！',
      userposition:'请选择职位！',
      student:'数据用途，导师姓名，导师邮箱 为必填项，请检查！',
      tutormailbox_detection:'导师邮箱格式不正确!',
      core:'数据用途 为必填项，请检查！',
      noncore:'数据用途,合作人姓名，合作人邮箱 为必填项，请检查！',
      partnersemail_detection:'合作人邮箱格式不正确!',
    },
  },
  LoginApplyDialogAppByPm: {
    application_information: '用户申请信息',
    appbulk_information: '批量申请信息',
    name: '姓名',
    useremail: '邮箱',
    applycop: '机构',
    cancel: '取消',
    ok:'确定',
    id:'提案ID',
    obs_id:'观测号',
    proposal:'提案号',
    remark:'数据用途',
    userposition:'职务',
    userposition_tip:'请选择职位',
    tutorinfo:'导师信息',
    tutorname:'导师姓名',
    tutoremail:'导师邮箱',
    tutoropion:'导师意见',
    partnersinfo:'合作人信息',
    partnersname:'合作人姓名',
    partnersemail:'合作人邮箱',
    partnersopion:'合作人意见',
    includeproposal:{
      one:'申请此观测数据',
      two:'申请该提案的所有数据',
      three:'申请提案下相同目标天体数据',
    },
    required:' * 必填项', 
    messinfo:{
      useremailbox_detection:'用户邮箱格式不正确，请联系注册系统管理员！',
      userposition:'请选择职位！',
      student:'数据用途，导师姓名，导师邮箱 为必填项，请检查！',
      tutormailbox_detection:'导师邮箱格式不正确!',
      core:'数据用途 为必填项，请检查！',
      noncore:'数据用途,合作人姓名，合作人邮箱 为必填项，请检查！',
      partnersemail_detection:'合作人邮箱格式不正确!',
    },
  },
  ObsInfo:{
    title:'观测详细信息页',
    homepage:'主页',
  },
  ProposalInfo:{
    title:'观测提案详细信息页',
    homepage:'主页',
  },
  TargetInfo:{
    title:'观测目标源详细信息页',
    homepage:'主页',
    src_name:'目标源',
    ra:'ra',
    dec:'dec',
    obs_id:'观测号',
    obs_time:'观测时间',
    duration:'观测时长',
    flux_h:'flux_h',
    flux_m:'flux_m',
    flux_l:'flux_l',
  },
  QuickLookInfo:{
    title:'快视页面',
    homepage:'主页',
  },
  DataRelease:{
    filepath:'文件路径',
    filesign:'文件标记',
    filever:'文件日期版本',
    ver:'文件序号版本',
    fileid:'文件ID',
    filelength:'文件大小',
    check:'检查',
    release:'发布',
    level:{
      '1L':'1L',
      '15L':'1.5L',
      '2L':'2L',
    },
  },
  AdminIndexdata:{
    visinfo:'游客申请信息',
    usrinfo:'用户申请信息',
    datatime:'数据时间',
  },
  UserVerify:{
    applicant:'申请人邮箱',
    closever:'取消授权',
    Applicationtype:'申请类型',
    includeproposal:{
      1:'观测数据',
      2:'提案数据',
      3:'同源数据',
    },
  },
  DataUppackage:{
    title:'数据升级包预览窗口',
  },
};
